import Grid from "@mui/material/Grid2";
import Box from "@mui/material/Box";
import ObjectDetails from "./ObjectDetails";


export default function ReportsGrid() {
  return (
    <Box sx={{ width: "100%", maxWidth: { sm: "100%", md: "1700px" } }}>
      <Grid container spacing={2} columns={12} alignItems="flex-start">
        <Grid size={{ xs: 12, lg: 12 }}>
          <ObjectDetails />
        </Grid>
      </Grid>
    </Box>
  );
}
